import INVESTMENT_GETTERS from './investmentGetters';
import FLAT_GETTERS from './flatGetters';

const GETTERS = {
  ...FLAT_GETTERS,
  ...INVESTMENT_GETTERS,
  GET_PLAN: () => id => {
    return `https://vacation.indigital.pl/investments/baltic_wave/PNG/baltic_wave-A-${id}.png`;
  },

  GET_PDF: () => id => {
    return `https://vacation.indigital.pl/investments/baltic_wave/PDF/baltic_wave-A-${id}.pdf`;
  },

  GET_3D: state => (
    id,
    folder = state.currentInvestment
      ? state.currentInvestment.assetsDirectory
      : null
  ) => {
    let url;
    try {
      url = require(`@/assets/${folder}/${
        state.flats3DDir
      }/${id.toLowerCase()}.png`);
    } catch (error) {
      url = false;
    }
    return url;
  },

  GET_STATUS_NAME: state => status => {
    if (!status) return false;

    switch (Number(status)) {
      case state.flatProperties['status_available']:
        if (window.location.pathname.includes('en')) {
          return 'Available';
        }
        if (window.location.pathname.includes('de')) {
          return 'Verfügbar';
        }
        return 'Dostępne';

      case state.flatProperties['status_reserved']:
        if (window.location.pathname.includes('en')) {
          return 'Booked';
        }
        if (window.location.pathname.includes('de')) {
          return 'Reserviert';
        }
        return 'Zarezerwowane';

      case state.flatProperties['status_sold']:
        if (window.location.pathname.includes('en')) {
          return 'Sold';
        }
        if (window.location.pathname.includes('de')) {
          return 'Verkauft';
        }
        return 'Sprzedane';
    }
  },
  GET_STATUS_CLASS: state => status => {
    if (!status) return false;

    switch (Number(status)) {
      case state.flatProperties['status_available']:
        return 'available';

      case state.flatProperties['status_reserved']:
        return 'reserved';

      case state.flatProperties['status_sold']:
        return 'sold';

      default:
        return false;
    }
  },
};

export default GETTERS;
